define([
    'react',
    'lodash'
], function (React, _) {
    'use strict';
    return function () {
        return React.createElement('span', { 'className': this.getClass() }, this.props.text);
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/status-boxes/status-box/status-box.rt
 ** module id = 223
 ** module chunks = 0
 **/